export default "__VITE_ASSET__BVaCagZK__"